// Barra fixa de compra no celular (snippets/mp-sticky-atc.liquid).
// Não envia nada por conta própria: espelha e aciona o botão original do Dawn.
if (!customElements.get('mp-sticky-atc')) {
  customElements.define(
    'mp-sticky-atc',
    class MpStickyAtc extends HTMLElement {
      connectedCallback() {
        // Nunca dentro de modais de compra rápida.
        if (this.closest('.quick-add-modal, modal-dialog')) {
          this.remove();
          return;
        }

        this.sectionId = this.dataset.section;
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.priceContainer = document.getElementById(`price-${this.sectionId}`);
        this.button = this.querySelector('[data-mp-sticky-button]');
        this.priceTarget = this.querySelector('[data-mp-sticky-price]');
        this.optionChosen = this.dataset.needsChoice !== 'true';
        if (!this.submitButton || !this.button) return;

        this.onChange = (event) => {
          if (event.target.closest(`variant-selects[data-section="${this.sectionId}"]`)) {
            this.optionChosen = true;
            this.sync();
          }
        };
        document.addEventListener('change', this.onChange);

        this.button.addEventListener('click', () => this.handleClick());

        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.priceContainer) {
          this.mutationObserver.observe(this.priceContainer, { childList: true, subtree: true, characterData: true });
        }

        this.intersectionObserver = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));
        this.intersectionObserver.observe(this.submitButton);
        this.sync();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
        if (this.onChange) document.removeEventListener('change', this.onChange);
        document.body.classList.remove('mp-sticky-atc-open');
      }

      toggle(show) {
        this.hidden = !show;
        document.body.classList.toggle('mp-sticky-atc-open', show);
      }

      handleClick() {
        if (!this.optionChosen) {
          const picker = document.getElementById(`variant-selects-${this.sectionId}`);
          const target = picker || this.submitButton;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const firstInput = picker?.querySelector('input:not([disabled]), select');
          firstInput?.focus({ preventScroll: true });
          return;
        }
        if (!this.submitButton.disabled) this.submitButton.click();
      }

      sync() {
        const label = this.submitButton.querySelector('span');
        const submitText = (label ? label.textContent : this.submitButton.textContent).trim();
        const unavailable = this.submitButton.disabled;
        this.button.textContent = this.optionChosen || unavailable ? submitText : this.dataset.chooseLabel;
        this.button.disabled = this.optionChosen && unavailable;

        if (!this.priceTarget) return;
        // Com o Pix em destaque (snippets/mp-price.liquid), mostra o mesmo valor principal.
        const pixPrice = this.priceContainer?.querySelector('[data-mp-sticky-text]');
        if (pixPrice) {
          this.priceTarget.textContent = pixPrice.dataset.mpStickyText;
          return;
        }
        const price = this.priceContainer?.querySelector('.price');
        if (!price) return;
        const current = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular');
        this.priceTarget.textContent = current ? current.textContent.trim() : '';
      }
    }
  );
}
